<section class="activity">
    <div class="left-bar" [ngStyle]="leftBarStyle">
        <div class="left-progress" [ngStyle]="leftProgressStyle"></div>
        <span class="low">{{ lowPoint }}</span>
        <span *ngIf="showMidPoint" class="mid">{{ midPoint }}</span>
    </div>
    <div *ngIf="overage" class="overage-bar" [ngStyle]="overageBarStyle">
        <div class="overage-progress" [ngStyle]="overageProgressStyle"></div>
        <span class="overage">{{ overagePoint }}</span>
    </div>
    <div *ngIf="overage" class="right-bar" [ngStyle]="rightBarStyle">
        <div class="right-progress" [ngStyle]="rightProgressStyle"></div>
        <span class="high">{{ highPoint }}</span>
    </div>
</section>
